import { render } from "./Uploads.vue?vue&type=template&id=670f617d"
import script from "./Uploads.vue?vue&type=script&lang=js"
export * from "./Uploads.vue?vue&type=script&lang=js"

import "./Uploads.vue?vue&type=style&index=0&id=670f617d&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__